<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing terms-conditions-card"
  >
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Before you register and conduct or download
        <strong>CESPT</strong> downloadable product(s) for your motives, please
        ensure you have read, acknowledged, and accepted all the terms. By using
        <strong>CESPT</strong> and/or other items, we believe you have agreed
        to the following terms and conditions.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Refunds</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We have a patron amicable 15 days
        <a href="#" target="_blank" class="text-decoration-none"
          >refund policy</a
        >. However, you can’t interrogate for a refund claiming a feature that
        your bought theme or plugin does not comprehend.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        <strong>1.</strong> Complimentary ground shipping within 1 to 7 business
        days<br />
        <strong>2.</strong> In-store collection available within 1 to 7 business
        days<br />
        <strong>3.</strong> Next-day and Express delivery options also
        available<br />
        <strong>4.</strong> Purchases are delivered in an orange box tied with a
        Bolduc ribbon, with the exception of certain items<br />
        <strong>5.</strong> See the delivery FAQs for details on shipping
        methods, costs and delivery times
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Product Delivery</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        All products can be downloadable upon buy. Products will be
        <i>unrestricted</i> for download after payment is received and verified.
        To process our payments, we use Stripe &amp; PayPal, which supports most
        debit and credit cards, i.e., MasterCard, Visa, American Express,
        Discover, JCB, etc. You must accept their terms and
        <u>conditions</u> before.
      </p>
      <ul>
        <li class="text-paragraph fs-md-15 fs-lg-16">
          Credit Card: Visa, MasterCard, Discover, American Express, JCB, Visa
          Electron. The total will be charged to your card when the order is
          shipped.
        </li>
        <li class="text-paragraph fs-md-15 fs-lg-16">
          <strong>CESPT</strong> features a Fast Checkout option, allowing you
          to securely save your credit card details so that you don't have to
          re-enter them for future purchases.
        </li>
        <li class="text-paragraph fs-md-15 fs-lg-16">
          PayPal: Shop easily online without having to enter your credit card
          details on the website.Your account will be charged once the order is
          completed. To register for a PayPal account, visit the website
          <a href="#" class="text-decoration-none" target="_blank"
            >paypal.com.</a
          >
        </li>
      </ul>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Your buying information will be mailed to your email address. You have
        to create an account on our site to download any of our products. There
        are some reasons that your payment is not completed, and after that, we
        need to investigate and process the download info manually. So, delays
        can be as long as 1 hour to 48 hours based on the situation and extent
        of investigation required after a fraud alert has been activated.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Product Updates</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        All themes and plugins are designed to be compatible with the latest
        version of WordPress. <strong>CESPT</strong> themes, templates, and
        plugins support the latest modern web browsers, including Chrome,
        Safari, Firefox, Brave, UC, Edge, Opera Mini, etc. Product updates are
        available to our customers for a lifetime.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Modifications</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        You can modify any of our products based on your needs/demands. But
        please remember that before modifying, check the documentation and tell
        us in the comment or support section if there is an easier and better
        way to make what you want.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Unauthorized Usage</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        You should not use the <strong>CESPT</strong> products for any
        unauthorized purpose in the use of the service, violate any laws in your
        jurisdiction (including but not limited to copyright laws), as well as
        the laws of the European Union and International law. Using our
        themes/templates/plugins is forbidden on websites that civilize
        violence, pornography, incivility content, or piracy links.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We reserve the right to block your user account instantly if we notice
        any improper usage.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        If you signed up on the <strong>CESPT.com</strong> website, you are
        liable for maintaining the safety of that, and you are fully responsible
        for all activities that happen under your account or any other
        operations that have taken from that. You must notify us without delay
        for any disallowed uses of your account.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Licensing and Usage</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Our items are licensed under the GNU General Public License v2.0.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Help/Support</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Once you have downloaded our product, you may contact us for
        help/support via comment or by sending a message from the item support
        zone, and we will do our best to review and fix your bug. We will try to
        provide a solution via comment, support ticket, or email. After that, we
        will update the core product. Themes, templates, and plugin support is
        offered to customers via comment, email, or support ticket.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        If your support demands extra product modification, you must hire an
        expert.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Proprietary</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        You may not claim intellectual or monopolistic ownership of any of our
        products, modified or not. All products are the belongings of
        <strong>CESPT</strong>. Our products are provided without any warranty,
        either published or not. In no case shall our legal person be
        responsible for any damages including, but not restricted to, direct,
        indirect, particular, incidental damages arising out of the use of our
        products.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        The above announcement is not authentic for those products which are
        released under the license of GNU/GPL (GNU GENERAL PUBLIC LICENSE). For
        more information about this license, please visit the GNU page.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Anti- juggle</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        However, our customer purchases can be pending for a manual anti-cheat
        checkup to review the payment system. You will receive an elaborate
        email about your payment. An anti-cheat check happens due to the
        progressive number of deceptive transactions from individuals who are
        not genuine cardholders of the credit cards used during purchases. The
        customer account can be ceased for a manual anti-cheat check for 24
        hours. Also, it can be ceased for a longer term for more investigations.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Price Changes</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        <strong>CESPT</strong> reserves the right at any time and from time to
        time to change or discard, provisionally or permanently, any product
        with or without prior notice.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">Warranty</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        <strong>CESPT</strong> products are provided “as is” without any
        warranty, either published or not. Each of the
        <strong>CESPT</strong> products is guaranteed to function correctly
        upon appropriate installation, activation, and options configuration of
        the product in the latest technologies stable versions to which
        theme/template/plugin was dedicated. <strong>CESPT</strong> cannot give
        guarantee compatibility with any 3rd party plugin – as there are too
        many plugins to support. Please ensure that the browsers you use will
        work with the themes/templates/plugins, as we guarantee that the
        <strong>CESPT</strong> themes/templates/plugins will work with all
        browser combinations.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We are not licensed to provide stock images and particular true-type
        fonts that might be used on any or all of the provided products. These
        require you to own or purchase from their respective owners. The
        images/videos we show in the demo versions of products are for
        demonstration motives, and you are not allowed to use them on production
        sites.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        All members have access to the comments. <strong>CESPT</strong> does
        not commit to monitoring the comments, but we reserve the right to
        respond and answer the questions.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We reserve the right to change and modify terms and conditions at any
        time without any prior notice.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsConditions",
};
</script>